module.exports = __webpack_public_path__ + "img/2_tommy.aada93bb.jpg";